import {  MenuItem, Button, Menu, List, makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import React, {useState} from 'react';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

export type SortCatagories =  
    "Name" | 
    "Created Date" | 
    "Last Opened" | 
    "Last Modified" | 
    "Preach Date" | 
    "Type" | 
    "Location" | 
    "Newest" | 
    "Popularity" 

const useStyles = makeStyles((theme) => ({
    crumbs: {
        color: "#5f6368",
        fontSize: "18px",
        fontWeight: 500,
        fontFamily: "Roboto, Helvetica",
        verticalAlign: "middle",
    },
    crumbButton: {
        borderRadius: "5px",
        textTransform: "none",
        paddingLeft: "0px",
        paddingRight: "0px"
    },
}));

interface Props {
    sortBy: SortCatagories;
    sortPremiumContent: boolean;
    handleSortByChange: (sort:SortCatagories) => void;
}

export function SortByDropDown(props: Props) {
    const { sortBy, sortPremiumContent } = props;
    const [anchorEl, setAnchorEl] = useState<HTMLElement | undefined>()
    const classes = useStyles();
    const handleSortChange = (sort:SortCatagories) => {
        setAnchorEl(undefined);
        props.handleSortByChange(sort)
    }

    return (
        <div>
            <span>
                <Button
                    size="small"
                    className={classNames(classes.crumbs, classes.crumbButton)}
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                    style={{padding: 0}}
                >
                    <span className={classes.crumbs}>Sort By: {sortBy}<ArrowDropDownIcon style={{ verticalAlign: "middle" }} /></span>
                </Button>
            </span>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(undefined)}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            >
                <span style={{ outline: "none" }}>
                    <List>
                        <MenuItem onClick={() => handleSortChange("Name")}>Name</MenuItem>
                        {!sortPremiumContent 
                        ?
                        <>
                            <MenuItem onClick={() => handleSortChange("Created Date")}>Created date</MenuItem>
                            <MenuItem onClick={() => handleSortChange("Last Opened")}>Last opened</MenuItem>
                            <MenuItem onClick={() => handleSortChange("Last Modified")}>Last modified</MenuItem>
                            <MenuItem onClick={() => handleSortChange("Preach Date")}>Preach date</MenuItem>
                            <MenuItem onClick={() => handleSortChange("Type")}>Type</MenuItem>
                            <MenuItem onClick={() => handleSortChange("Location")}>Location</MenuItem>
                        </>
                        :
                        <>
                            <MenuItem onClick={() => handleSortChange("Newest")}>Newest</MenuItem>
                            <MenuItem onClick={() => handleSortChange("Popularity")}>Popularity</MenuItem>
                        </>
                        }
                    </List>
                </span>
            </Menu>

        </div>
    );
}